export default `
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="28" height="41" viewBox="0 0 28 41">
    <defs>
      <ellipse id="b" cx="13" cy="31.5" rx="5" ry="2.5"/>
      <filter id="a" width="240%" height="380%" x="-70%" y="-100%" filterUnits="objectBoundingBox">
        <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1"/>
        <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="2"/>
        <feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0.117647059 0 0 0 0 0.145098039 0 0 0 0 0.207843137 0 0 0 0.2 0"/>
      </filter>
    </defs>
    <g fill="none" fill-rule="evenodd">
      <path d="M-10-5h48v48h-48z"/>
      <g transform="translate(1 1)">
        <use fill="#000" filter="url(#a)" xlinkhref="#b"/>
        <path fill="currentColor" stroke="#FFF" d="M13.066 32c5.066-8.8 13.066-9.866 13.066-18.934C26.132 5.866 20.266 0 13.066 0 5.866 0 0 5.866 0 13.066 0 22.132 8 23.466 13.066 32z"/>
        <circle cx="13.1" cy="13" r="5" fill="#FFF"/>
      </g>
    </g>
  </svg>
`;
